module.exports = {"371302001":"兰山街道","371302002":"银雀山街道","371302003":"金雀山街道","371302004":"柳青街道","371302101":"白沙埠镇","371302102":"枣园镇","371302103":"半程镇","371302105":"义堂镇","371302107":"李官镇","371302109":"方城镇","371302110":"汪沟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371302.json
// module id = 1575
// module chunks = 0